import React from "react";
import classNames from "classnames";

import IconSvg from "components/IconSvg";

type TileButtonProps = {
  category: "effects" | "flavors";
  className?: string;
  disabled?: boolean;
  isSelected?: boolean;
  name: string;
  onClick: () => void;
  slug: string;
};

const TileButton = ({
  category,
  className = "",
  disabled = false,
  isSelected = false,
  name,
  onClick,
  slug,
}: TileButtonProps): JSX.Element => {
  return (
    <button
      className={classNames(
        "flex flex-col items-center border-2 text-xs py-md w-full cursor-default rounded overflow-hidden",
        { "border-light-grey": !isSelected },
        { "cursor-pointer": !disabled },
        { "opacity-50": disabled },
        className
      )}
      onClick={onClick}
      type="button"
      disabled={disabled}
      data-testid="tile-button"
    >
      <IconSvg
        height="24"
        width="24"
        filePath={`${category}/${slug}.svg`}
        className="block mb-xs"
      />
      <span className="font-bold leading-none mb-xs w-full truncate">
        {name}
      </span>
    </button>
  );
};

export default TileButton;
